var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",class:[
               {'justify-center' :  _vm.EMAIL_CONFIG.logo_align=== 'center'},
               {'justify-end' :  _vm.EMAIL_CONFIG.logo_align=== 'right'}
     ]},[(!_vm.EMAIL_CONFIG.logo)?_c('ws-logo',{attrs:{"title":_vm.$store.state.business.selectedBusiness.name}}):_c('img',{attrs:{"src":_vm.EMAIL_CONFIG.logo,"height":((_vm.EMAIL_CONFIG.logo_height || 50) + "px"),"width":"auto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }